import { CLASSROOM_API, LicensedFeature, LicensedFeaturesResonseShape } from "./api/ClasswizeLicencing";

export interface ClassroomLicenseStatus {
  classroomLicenseActivated: boolean;
  coursesLicenseActivated: boolean;
}

export async function fetchLicensedFeatures(): Promise<ClassroomLicenseStatus> {
  const response: Response = await CLASSROOM_API.getLicencedFeatures();
  const responseData: LicensedFeaturesResonseShape = (await response.json()) as LicensedFeaturesResonseShape;

  return {
    classroomLicenseActivated: responseData.features.includes(LicensedFeature.Classroom),
    coursesLicenseActivated: responseData.features.includes(LicensedFeature.Courses),
  };
}
